import { Link } from "react-router";
import { Zap } from "lucide-react";

import { cn } from "@/lib/utils";
import { useCanAutoQualify } from "@/hooks/useCanAutoQualify";
import { useQualificationAnalysis } from "@/hooks/useQualificationAnalysis";

/**
 * Si la línea tiene el análisis de calificación, junto a su nombre. Se administra en
 * Documentos, así que la píldora lleva allá. Antes de activarlo no se pinta: ya
 * invita el banner.
 */
export function LineAnalysisPill({ lineId }: { lineId: number }) {
  const canAutoQualify = useCanAutoQualify();
  const { status, isLineMarked } = useQualificationAnalysis(lineId);

  if (!canAutoQualify || status === "INACTIVE") return null;

  return (
    <Link
      to="/settings/documents"
      title={
        isLineMarked
          ? "Analizamos en qué obras de esta línea calificas. Se administra en Documentos."
          : "Si postulas en esta línea, actívalo en Documentos."
      }
      className={cn(
        "inline-flex cursor-pointer items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold transition-colors",
        isLineMarked
          ? "bg-primary/10 text-primary hover:bg-primary/15"
          : "border border-dashed text-muted-foreground hover:bg-accent",
      )}
    >
      <Zap className="size-3" />
      {isLineMarked ? "Análisis de calificación activo" : "Sin análisis de calificación · Activar"}
    </Link>
  );
}
